module.exports = __webpack_public_path__ + "img/icon-pedidos-material-operativo.7ab9db55.svg";